const DROPDOWN_MIN_WIDTH = 300

export default DROPDOWN_MIN_WIDTH
